/** 我的站内信页面路径（不在菜单展示，由通知入口跳转） */
export const SITE_MESSAGE_INBOX_PATH = '/in-site-message/inbox';
